import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ContentStateService} from '../content/content-state.service';
import {ContentDetails} from '../../model/typings/content.types';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {NavItem} from '../../model/typings/nav.types';
import {ViewContent} from '../../model/typings/view.types';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class ContentService {
  viewContentApiUrl = 'api/view-content';
  viewNavItemsApiUrl = 'api/view-nav-items';
  contentDetailsApiUrl = 'api/content-details';
  isLoading = true;
  isLoadingObservable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isLoading);

  constructor(private http: HttpClient,
              private contentStateService: ContentStateService) {
  }

  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
    this.isLoadingObservable.next(this.isLoading);
  }

  getContentDetailsById(options: { contentDetailsId: string, updateState: boolean }): Observable<any> {
    const params = {};
    const contentDetailsByIdUrl = `${environment.resourceServer + this.contentDetailsApiUrl}/${options.contentDetailsId}`;
    this.setLoading(true);

    console.log(`CPUI - ContentService.getContentDetailsById()`, options, contentDetailsByIdUrl);

    return this.http.get<Object>(contentDetailsByIdUrl,
      {params, withCredentials: true})
      .map((response) => this.handleContentDetailsResponse(response));
  }

  private handleContentDetailsResponse(response: any): ContentDetails {
    console.log(`CPUI - ContentService.handleContentForViewResponse()`);
    this.setLoading(false);
    return response;
  }

  getContentForView(options: { viewId: string, updateState: boolean }): Observable<any> {
    const params = {};
    const viewId = options.viewId;
    const contentForViewUrl = `${environment.resourceServer + this.viewContentApiUrl}/${options.viewId}`;
    this.setLoading(true);

    console.log(`CPUI - ContentService.getContentForView()`, options, contentForViewUrl);

    if (options.updateState) {
      if (this.contentStateService.hasViewContentCache(viewId)) {
        return this.updateContentForViewInCache(viewId);
      } else {
        return this.http.get<any>(contentForViewUrl,
          {params, withCredentials: true})
          .map((response) => this.updateContentForViewInState(viewId, response));
      }
    } else {
      return this.http.get<Object>(contentForViewUrl,
        {params, withCredentials: true})
        .map((response) => this.handleContentForViewResponse(response));
    }
  }

  private handleContentForViewResponse(response: any): ViewContent {
    console.log(`CPUI - ContentService.handleContentForViewResponse()`);
    this.setLoading(false);
    return response;
  }

  private updateContentForViewInState(viewId: string, response: any): ViewContent {
    console.log(`CPUI - ContentService.updateContentForViewInState()`);
    this.setLoading(false);
    return this.contentStateService.updateContentForView(viewId, response);
  }

  private updateContentForViewInCache(viewId: string): Observable<ViewContent> {
    console.log(`CPUI - ContentService.updateContentForViewInCache()`);
    this.setLoading(false);
    return this.contentStateService.getViewContentCache(viewId);
  }

  getNavItemsForView(options: { viewId: string, updateState: boolean }): Observable<any> {
    const params = {};
    const navItemsForViewUrl = `${environment.resourceServer + this.viewNavItemsApiUrl}/${options.viewId}`;

    console.log(`CPUI - ContentService.getNavItemsForView()`, options, navItemsForViewUrl);

    return this.http.get<Object>(navItemsForViewUrl,
      {params, withCredentials: true})
      .map((response) => this.handleNavItemsForViewResponse(response));
  }

  private handleNavItemsForViewResponse(response: any): NavItem[] {
    console.log(`CPUI - ContentService.handleContentForViewResponse()`);
    return response && response.navItems ? response.navItems : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/content/content.service.ts